import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ClassPerformanceAnalytics from "PerformanceAnalytics/routes/ClassPerformanceAnalytics";
export default store => {
  return {
    path: ":staffId",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "staff-overview" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [ClassPerformanceAnalytics(store)],
  };
};
